import React, { Component } from 'react';
import { css } from 'aphrodite';

import { ReportBox, ColorEnvironment, Font, Text, Flexbox } from './Styles';

import Image from './Image';
import Cost from './Cost';
import ButtonSet from './ButtonSet';

import Locale from './models/Locale';

class ActionInfo extends Component {
  render() {
    let actions = [];
    if (this.props.onSelect) {
      actions.push([Locale.localized('Get Action'), this.props.onSelect]);
    }
    actions.push([Locale.localized('Go Back'), this.props.onCancel]);
    return(
      <div className={css(Flexbox.column, Flexbox.axisStart, Flexbox.crossCenter)}>
        <div className={css(Flexbox.column, Flexbox.axisStart, Flexbox.crossCenter, ReportBox.container, ColorEnvironment.normal)}>
          <Image extraStyles={ReportBox.topImage} filename={this.props.action.iconFilename} />
          <div className={css(Font.heading, Text.heading)}>{this.props.action.description}</div>
          <div className={css(Flexbox.grow, Font.body, Text.textBlock)}>{this.props.action.rationale}</div>
          <Cost cost={this.props.action.cost}/>
          <ButtonSet buttons={actions} />
        </div>
      </div>
    );
  }
}

export default ActionInfo;



// WEBPACK FOOTER //
// ./src/ActionInfo.js